import { CONFIGS } from "@/constants/configs";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Translations = Record<string, any>;

/** Walks a dot path ("theme.dark") through the translations. */
function lookup(translations: Translations, key: string): string | undefined {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let value: any = translations;
  for (const k of key.split(".")) {
    if (value && typeof value === "object" && k in value) {
      value = value[k];
    } else {
      return undefined;
    }
  }
  return typeof value === "string" ? value : undefined;
}

/**
 * Translation key for a machine code ("pending_review" -> "pending review").
 * Keys are spaced words, never snake_case, while codes shared with the API
 * keep their underscores.
 */
export function keyFor(code: string): string {
  return code.replaceAll("_", " ");
}

/**
 * The brand in the visitor's language. The name comes from the env
 * (NEXT_PUBLIC_APP_NAME, e.g. "Rawej") and is translated through
 * `brand.<name lowercased>` ("ڕاۆێژ" in fa/ckb), falling back to the name.
 */
export function appName(translations: Translations): string {
  const name = CONFIGS.app.name;
  return lookup(translations, `brand.${name.toLowerCase()}`) ?? name;
}

/**
 * Get nested translation value using dot notation
 * Example: t('theme.dark') returns translations.theme.dark
 *
 * `{{app}}` in a text (or its fallback) becomes the translated brand, so no
 * translation hard-codes the product name.
 */
export function getTranslation(
  translations: Translations,
  key: string,
  fallback?: string,
): string {
  const value = lookup(translations, key) ?? (fallback || key);
  return value.includes("{{app}}") ? value.replaceAll("{{app}}", appName(translations)) : value;
}
